// extracted by mini-css-extract-plugin
export default {"errorStatePage":"fcg7sD","errorStatePageTitle":"NfGbZJ"};